<script>
  import options from './CalendarOverlay.options'
  export default options
</script>

<template>
  <article class="kb-calendar-overlay">
    <section class="kb-calendar-overlay__hero">
      <div class="kb-calendar-overlay__hero__title-wrapper">
        <h2 class="kb-calendar-overlay__hero__title-wrapper__title">
          {{ getLabel('title') }}
        </h2>
      </div>
    </section>

    <div class="kb-calendar-overlay__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-calendar-overlay__body">
      <ul class="kb-calendar-overlay__list">
        <li class="kb-calendar-overlay__list__item" v-for="activity, index in activities" :key="index">
          <ActivityCard v-if="!allowedToEdit" :result="activity" :hideStatus="true" :hideEdit="true" />
          <ActivityCard v-else :result="activity" :deleteCallback="deleteEvent" :hideStatus="true" />
        </li>
      </ul>

      <div class="kb-calendar-overlay__actions" v-if="allowedToEdit">
        <a :href="createEventUrl">
          <button class="kb-button kb-button--full-color">
            {{ getLabel('createButtonText') }}
          </button>
        </a>
      </div>

    </div>

  </article>
</template>
